export default "__VITE_ASSET__DPYlNGaG__"